module.exports = ".ipt-error {\n  color: #dd4b57;\n  font-weight: 500;\n  margin-left: 0.1em; }\n  .ipt-error.lite {\n    margin-left: 1.2em; }\n"